import { Subscript } from '@tiptap/extension-subscript'

export function createSubscriptExtension() {
    return Subscript.configure({})
}
